module.exports = __webpack_public_path__ + "static/media/3.90a6a077.jpg";